import { render, staticRenderFns } from "./BookingRequestView.vue?vue&type=template&id=fd0a7348"
import script from "./BookingRequestView.vue?vue&type=script&lang=js"
export * from "./BookingRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports